/**
 * Created by razial on 05.07.2024.
 */

const Composite = function (unit) { 
    UnitComponent.call(this, unit);
};

Composite.prototype = Object.create(UnitComponent.prototype);
Composite.prototype.constructor = Composite;

Composite.prototype.onShowTile = function () {
    this.removeParts();
    this.createParts();
};

Composite.prototype.onHideTile = function () {
    this.removeParts();
};

Composite.prototype.setVisible = function (visible) {
    if (this.view) {
        this.view.setPartsVisibility(visible);
    }
};

Composite.prototype.showPartsUp = function () {
    if (this.view) {
        this.view.showPartsUp();
    }
};

Composite.prototype.updateOutline = function () {
    if (this.view) {
        this.view.updatePartsOutline();
    }
};

Composite.prototype.createParts = function () {
    if (this.view) {
        this.view.createParts();
    }
};

Composite.prototype.removeParts = function () {
    if (this.view) {
        this.view.removeParts();
    }
};

Composite.prototype.getBelowShapeOffset = function () {
    const shape = this.unit.getShape().slice().sort(cc.isoRectComparator);
    const selected = shape[0];
    return { x: selected.x, y: selected.y, unitView: true };
};

Composite.prototype.getAboveShapeOffset = function () {
    const shape = this.unit.getShape().slice().sort(cc.isoRectComparator);
    const selected = shape[shape.length - 1];
    return { x: selected.x, y: selected.y, zOrder: 20 };
};

Composite.prototype.offsetFromAnimation = function (animationName) {
    if (animationName === "animation_below") {
        return this.getBelowShapeOffset();
    }

    if (animationName === "animation_above") {
        return this.getAboveShapeOffset();
    }

    const match = animationName.match(/^animation_(-?\d+)_(-?\d+)$/);
    if (match) {
        const x = parseInt(match[1]), y = parseInt(match[2]);
        if (Number.isFinite(x) && Number.isFinite(y)) {
            return { x, y };
        }
    }
};
